import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "movies-area pb-100" }
const _hoisted_2 = { class: "container mw-1356" }
const _hoisted_3 = {
  class: "section-title mw-690 m-auto text-center",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "100"
}
const _hoisted_4 = { class: "container-fluid p-0" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "text-center mt-4 pt-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "top-title" }, "استمتع بوقتك", -1)),
        _createElementVNode("h2", {
          class: _normalizeClass(_ctx.className)
        }, " استمتع بمشاهدة الأفلام والمسلسلات والبرامج والأنمي والمزيد ", 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Swiper, {
        slidesPerView: 1,
        spaceBetween: 24,
        centeredSlides: false,
        preventClicks: true,
        loop: true,
        autoplay: {
          delay: 8000,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
          },
          576: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 3,
          },
          992: {
            slidesPerView: 4,
          },
          1200: {
            slidesPerView: 5,
          },
          1440: {
            slidesPerView: 6,
          },
        },
        modules: _ctx.modules,
        class: "movies-slide"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slides, (slide) => {
            return (_openBlock(), _createBlock(_component_SwiperSlide, {
              key: slide.id
            }, {
              default: _withCtx(() => [
                _createVNode(_component_RouterLink, { to: "/services-details" }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: slide.image,
                      alt: "movie"
                    }, null, 8, _hoisted_5)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["modules"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-silver" }, " كل ما تحتاجه للاستمتاع بأفضل تجربة مشاهدة ", -1)),
      _createVNode(_component_RouterLink, {
        to: "/pricing-plan",
        class: "btn"
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createElementVNode("span", { class: "border-style" }, "اشترك الآن", -1)
        ]))]),
        _: 1
      })
    ])
  ]))
}